import request from '@/utils/request'
import { getCommunityId } from '@/api/community/communityApi'

// 获取房产浏览记录列表
export function listBuildingBrowses(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/building.listBuildingBrowses',
      method: 'get',
      params: {
        ...params,
        communityId: getCommunityId()
      }
    }).then(response => {
      const res = response.data
      // 检查返回的数据结构，兼容不同格式
      let browsesData = [];
      let total = 0;
      
      if (res.browses) {
        // 如果后端返回的是包含browses字段的对象
        browsesData = res.browses;
        total = res.total || res.browses.length;
      } else if (Array.isArray(res)) {
        // 如果后端直接返回数组
        browsesData = res;
        total = res.length;
      } else if (res.data) {
        // 如果后端返回的是包含data字段的对象
        browsesData = res.data;
        total = res.total || (Array.isArray(res.data) ? res.data.length : 0);
      } else {
        // 其他情况，假设整个response就是数据
        browsesData = [res]; // 包装成数组
        total = 1;
      }
      
      resolve({
        data: browsesData,
        total: total
      })
    }).catch(error => {
      reject(error)
    })
  })
}

// 获取房产浏览记录详情
export function getBuildingBrowseDetail(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/building.listBuildingBrowses',
      method: 'get',
      params: {
        ...params,
        communityId: getCommunityId()
      }
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 添加房产浏览记录
export function saveBuildingBrowse(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/building.saveBuildingBrowse',
      method: 'post',
      data: {
        ...data,
        communityId: getCommunityId()
      }
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 更新房产浏览记录
export function updateBuildingBrowse(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/building.updateBuildingBrowse',
      method: 'post',
      data: {
        ...data,
        communityId: getCommunityId()
      }
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 删除房产浏览记录
export function deleteBuildingBrowse(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/building.deleteBuildingBrowse',
      method: 'post',
      data: {
        ...params,
        communityId: getCommunityId()
      }
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}